import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import RelatedFopsContainer from '../../containers/RelatedFopsContainer';
import containerTypes from 'apps/analytics/utils/containerTypes';
import SectionType from 'apps/catalogue/models/SectionType';
import getProductsBySku from '../../utils/getProductsBySku';

import { wa } from 'apps/analytics';
import { pageEvents } from 'apps/products/analytics';
import sendSingleSectionProductImpressions from 'apps/products/utils/sendSingleSectionProductImpressions';

const gtmPageType = 'Back of pack';
const section = {
  attributes: {
    type: SectionType.YOU_MIGHT_LIKE,
    title: 'You might like',
  },
};

const YouMightLike = ({ recommendations }) => {
  const { sections = [] } = recommendations || {};
  const firstSection = sections[0] || {};
  const { fops = [] } = firstSection;
  const hasRecommendations = fops.length > 0;

  useEffect(sendAnalytics, [hasRecommendations]);

  function sendAnalytics() {
    if (!hasRecommendations) {
      return;
    }

    wa.triggerPageEventWithDescription(pageEvents.BOP_YOU_MIGHT_LIKE_SHOWN);
    sendSingleSectionProductImpressions(firstSection, gtmPageType, section);
  }

  if (!hasRecommendations) {
    return null;
  }

  return (
    <section className="bop-section bop-fops" id="recommendationsScrollId">
      <h3 className="bop-fops__header">You might also like</h3>
      <div className="bop-fops__wrapper">
        <div className="bop-fops__items">
          <RelatedFopsContainer
            containerType={containerTypes.YOU_MIGHT_LIKE}
            fopCollection={firstSection}
            gtmPageType={gtmPageType}
            productsBySku={getProductsBySku(firstSection)}
            skipAnalytics
          />
        </div>
      </div>
    </section>
  );
};

YouMightLike.propTypes = {
  recommendations: PropTypes.object,
};

export default YouMightLike;
